import { generateId, getRandomText } from '@freelancer/datastore/testing';
import * as common from 'api-typings/common/common';
import {
  SearchFiltersProjectSortingOptionApi,
  SearchFiltersProjectTypeApi,
  SearchFiltersProjectUpgradeApi,
} from 'api-typings/users/users';
import {
  SearchSavedFilters,
  SearchSavedFiltersProjectLocation,
} from './search-saved-filters.model';

export interface GenerateSearchSavedFiltersOptions {
  readonly userId: number;
  readonly name?: string;
  readonly type?: common.SearchTypeApi;
  readonly clientCountryCodes?: readonly string[];
  readonly countryCode?: string;
  readonly keyword?: string;
  readonly languageCodes?: readonly string[];
  readonly location?: SearchSavedFiltersProjectLocation;
  readonly maxFixedPrice?: number;
  readonly maxHourlyRate?: number;
  readonly minFixedPrice?: number;
  readonly minHourlyRate?: number;
  readonly poolIds?: readonly number[];
  readonly projectTypes?: readonly SearchFiltersProjectTypeApi[];
  readonly skillIds?: readonly number[];
  readonly sortingOption?: SearchFiltersProjectSortingOptionApi;
  readonly upgrades?: readonly SearchFiltersProjectUpgradeApi[];
}

export function generateSearchSavedFiltersObject({
  userId,
  name = getRandomText(1, 50),
  type = common.SearchTypeApi.PROJECT,
  clientCountryCodes,
  countryCode,
  keyword,
  languageCodes,
  location,
  maxFixedPrice,
  maxHourlyRate,
  minFixedPrice,
  minHourlyRate,
  poolIds,
  projectTypes,
  skillIds,
  sortingOption,
  upgrades,
}: GenerateSearchSavedFiltersOptions): SearchSavedFilters {
  return {
    id: generateId(),
    filters: {
      clientCountryCodes,
      countryCode,
      keyword,
      languageCodes,
      location,
      maxFixedPrice,
      maxHourlyRate,
      minFixedPrice,
      minHourlyRate,
      poolIds,
      projectTypes,
      skillIds,
      sortingOption,
      upgrades,
    },
    name,
    type,
    userId,
  };
}
